<template>
  <section id='page-playback'>
    <player
      :playUrl="playUrl"
      @waiting="clearReportVideoView"
      @playing="playerPlaying"
      @pause="clearReportVideoView"
      @ended="playerEnd"
    >
      <topBar :viewReport='viewReport' />
    </player>

  </section>
</template>

<script>
/* eslint-disable import/no-cycle */
import { mapActions } from 'vuex';
import topBar from '@/components/video/live-top-bar/index.vue';
import { apiReportRecord } from '@/api/playback/index';

export default {
  name: 'playback',
  components: {
    topBar,
  },
  data() {
    return {
      timer: null,
      viewTime: 0,
      playUrl: '',
      viewReport: window.sessionStorage.getItem('playbackCount'),
    };
  },
  created() {
    const { userId } = this.$route.query;
    this.getUserInfo({ userId });
  },
  mounted() {
    this.$NProgress.done();
    this.playUrl = window.sessionStorage.getItem('playbackUrl');
  },
  beforeDestroy() {
    this.clearReportVideoView();
  },
  methods: {
    ...mapActions({
      getUserInfo: 'getUserInfo',
    }),
    // 播放时间上报
    reportVideoView(isEnd = false) {
      const { snowId } = this.$route.query;
      this.viewTime += 5;
      let { viewTime } = this;
      if (isEnd) {
        viewTime = document.querySelector('video').currentTime.toFixed(1);
      }
      apiReportRecord({
        isEnd,
        snowId,
        viewTime,
        channel: window.sessionStorage.getItem('channel'),
      });
    },
    // 清除上报
    clearReportVideoView() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 视频播放
    playerPlaying() {
      this.timer = setInterval(() => {
        this.reportVideoView();
      }, 5000);
    },
    // 播放结束
    playerEnd() {
      this.clearReportVideoView();
      this.reportVideoView(true);
      this.viewTime = 0;
    },
  },
};
</script>

<style lang='less'>
#page-playback {
  .top-bg{
    top: 0;
    position: absolute;
    left: 0;
    right: 0;
  }
  .dplayer {
    height: 100vh;
  }
    #dplayer {
      .dplayer-controller .dplayer-icons-left {
        display: block;
        bottom: 10px;
      }
      .dplayer-controller .dplayer-bar-wrap {
        width: 100%;
        bottom: 30px;
        left: 0;
        z-index: 100002;
        padding: 20px;
        box-sizing: border-box;
        display: block;
      }
      .dplayer-controller {
        display: block;
        div{
          display: none;
        }
        .dplayer-bar {
          display: block;
          >div {
            display: block;
          }
        }
      }
  }
}
</style>
